export type SystemParameters = {
  LastMonthlyReportProcessingDate: Date,
  LastWeeklyReportProcessingDate: Date,
  emailLastAt: Date,
  privacyPolicyUrl: Date,
  outputPageCount: number
};

export type CreateState = {
  id: string;
  tenantId?: string;
  deleteFlg?: boolean;
  userCount: number;
  createCount: number;
  status: "inOparation" | "standBy" | "completion" | "error";
  missingNumber?: number[];
  startUserId?: number;
};

export type FileData = {
  status: string;
  fileName?: string;
  createNo?: string;
  createCount: number;
  firstUserId: string;
  lastUserId: string;
  filePath?: string;
}

export type LoginPdfCreateState = {
  id: string;
  tenantId: string;
  status: string;
  files: FileData[];
  createUserUid: string;
  createAt: Date;
  completionAt?: Date;
  zipFileName?: string;
  zipFilePath?: string;
  listFlg?: boolean;
};

export type UserCardCreateState = {
  id: string;
  createNo?: string;
  tenantId: string;
  status: "waitRequest" | "standBy" | "inOperation" | "completion" | "impossible";
  attachmentAt: Date;
  createCount: number;
  createAt?: Date | null;
  excelFileName?: string;
  excelFilePath?: string;
  dispExcelFileName?: string;
  pdfFileName?: string;
  pdfFilePath?: string;
  createUserUid?: string;
  requestAt?: Date | null;
  errorUserMaps: ErrorUserMap[];
  requestUserUid: string;
};

export type ErrorUserMap = {
  userId: string;
  userName: string;
  message: string[];
};

export type SystemParameter00000001 = {
  optionContract: optionContractConfig[];
  userIdCardRequestLimitFlg: boolean;
  userIdCardMaxRequestCount: number;
  userIdCardMaxRequestSheet: number;
};

export type optionContractConfig = {
  userIdCard: optionConfig;
};

export type optionConfig = {
  optionName: string;
  sort: number;
  status: boolean;
};

export const userCardTimestampToDate = (data: any | undefined): UserCardCreateState => {
  if(data.requestAt && data.requestAt !== null){
    data.requestAt = new Date(data.requestAt.seconds * 1000);
  }
  return data;
};